module.exports = __webpack_public_path__ + "img/meeting-triple-icon.5b8a57d6.svg";